<template>
  <div class="m-table-container">
    <div style="padding: 6px 0;" v-if="tableButtons && (tableButtons.systemButtons&&tableButtons.systemButtons.length > 0 || tableButtons.customButtons&&tableButtons.customButtons.length > 0 || tableButtons.primaryButtons&&tableButtons.primaryButtons.length > 0)">
        <span slot="buttonLeft" style="display:inline-block"><slot name="buttonLeft"></slot></span>
        <m-buttons style="display:inline-block" :custom-buttons="tableButtons.customButtons" :primary-buttons="tableButtons.primaryButtons" :system-buttons="tableButtons.systemButtons" :upload-button="tableButtons.uploadButton" @onSystemBtnClick="onSystemBtnClick" @onCustomBtnClick="onCustomBtnClick">
        <span slot="tips"><slot name="tips"></slot></span>
      </m-buttons>
      <span slot="buttonRight" style="display:inline-block"><slot name="buttonRight"></slot></span>
    </div>
    <div style="padding: 2px 0" v-if="titleRemarksShow" v-html="titleRemarks"></div>
    <Table size="small" ref="iTable" :row-class-name="rowClassName" highlight-row border :height="height" :columns="columns.columns" :width="columns.width" :data="data" :loading="loading" :noDataText="noDataText" :thDrag="thDrag" :columnDrag="columnDrag" @on-row-click="rowClick" @on-row-dblclick="onRowDblclick" @on-select="select" @on-select-cancel="selectCancel" @on-selection-change="selectionChange" @on-select-all="selectAll" @on-expand="expand">
      <div slot="header">
        <slot name="tableHeader"></slot>
      </div>
    </Table>
  </div>
</template>

<script>
  import mButtons from '../buttons/index';
  import {tableBtnNames} from '../buttons/config';
  import scrollBar from '@/utils/table-scroll-bar.js';
  import sticky from '@/utils/sticky.js';
  export default {
    name: 'mTable',
    components: {mButtons},
    mixins: [scrollBar, sticky],
    data() {
      return {
        parent: 'm-table-container',
        that: this,
        selection: [],
        checkboxColumn: {
          type: 'selection',
          width: 60,
          align: 'center'
        }, // 选择列定义
        buttonsColumn: {
          renderHeader: (h, params) => {
            return h('span', this.$t('page.table.tOperation'));
          },
          key: 'action',
          width: this.columns.buttons ? this.columns.buttons.columnWidth : 0,
          align: 'center',
          render: (h, params) => {
            return h('div', this.makeUpButtons(h, params));
          }
        } // 操作列定义（接收用户自定义的配置）
      };
    },
    props: {
        needScrollBar: {
            type: Boolean,
            default: false
        },
        needSticky: {
            type: Boolean,
            default: false
        },
      rowClassName: {},
      noDataText: {
        type: String,
        default () {
          return this.$t('page.table.noDataText');
        }
      },
      tableButtons: {
        type: Object,
        default() {
          return {
            systemButtons: {
              type: Array,
              default() {
                return [];
              }
            },
            customButtons: {
              type: Array,
              default() {
                return [];
              }
            },
            primaryButtons: {
                type: Array,
                default() {
                    return [];
                }
            },
              uploadButton: {
                type: Object,
                  default() {
                    return {};
                  }
              }
          };
        }
      }, // 表头按钮
      columns: {
        type: Object,
        default() {
          return {
            showCheckbox: { type: Boolean, default: true },
            columns: { type: Array, default() { return []; } },
            buttons: {
              type: Object,
              default() {
                return {
                  view: {
                    type: Boolean,
                    default: false
                  },
                  edit: {
                    type: Boolean,
                    default: false
                  },
                  delete: {
                    type: Boolean,
                    default: false
                  },
                  selfDef: {
                    type: Array,
                    default() {
                      return [];
                    }
                  }
                };
              }
            }
          };
        }
      }, // 数据列定义
      data: {
        type: Array,
        default() {
          return [];
        }
      }, // 表格数据
      loading: {
        type: Boolean,
        default: false
      }, // 是否显示正在加载
      height: {
          type: Number,
          default: null
      },
      thDrag: {
        type: Boolean,
        default: false
      },
      columnDrag: {
        type: Boolean,
        default: false
      },
      titleRemarksShow: {
        type: Boolean,
        default: false
      }, // 是否展示按钮与表格之间的备注描述
      titleRemarks: {
        type: String,
        default: ''
      } // 按钮与表格之间的备注描述
    },
    computed: {
      cTxtView() {
        return this.$t('page.table.tView');
      },
      cTxtEdit() {
        return this.$t('page.table.tEdit');
      },
      cTxtDelete() {
        return this.$t('page.table.tDelete');
      }
    },
    methods: {
      /**
       * 单击某一行时触发
       * @param row 当前行数据
       * @param index 当前行索引
       */
      rowClick(row, index) {
        this.$emit('rowClick', row, index);
      },
      /**
       * 双击某一行时触发
       * @param row 当前行数据
       * @param index 当前行索引
       */
      onRowDblclick(row, index) {
        this.$emit('onRowDblclick', row, index);
      },
      /**
       * 在多选模式下有效，选中某一项时触发
       * @param selection 已选项数据
       * @param row 刚选择的项数据
       */
      select(selection, row) {
        this.$emit('select', selection, row);
      },
      selectCancel(selection, row) {
        this.$emit('selectCancel', selection, row);
      },
      selectionChange(selection) {
        this.selection = selection;
        this.$emit('onSelectionChange', selection);
      },
      /**
       * 在多选模式下有效，点击全选时触发
       * @param selection 已选项数据
       */
      selectAll(selection) {
        this.$emit('selectAll', selection);
      },
        /**
         * 在多选模式下有效，点击全选时触发
         * @param row 当前行的数据; status：当前的状态
         */
        expand(row, status) {
            this.$emit('expand', row, status);
        },
      /**
       * 组装操作列的按钮
       */
      makeUpButtons(h, params) {
        let res = [];
        if (this.columns.buttons) {
          if (this.columns.buttons.view) {
            res.push(h('Button', {
              props: {
                type: (this.columns.buttons.view.icon && !this.columns.buttons.view.label) ? 'text' : (this.columns.buttons.view.type ? this.columns.buttons.view.type : 'default'),
                size: (this.columns.buttons.view.icon && !this.columns.buttons.view.label) ? 'large' : 'small',
                icon: this.columns.buttons.view.icon ? 'eye' : ''
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$emit('onView', params.row, params.column, params.index);
                }
              }
            }, this.columns.buttons.view.label ? this.cTxtView : ''));
          }
          if (this.columns.buttons.edit) {
            res.push(h('Button', {
              props: {
                type: (this.columns.buttons.edit.icon && !this.columns.buttons.edit.label) ? 'text' : (this.columns.buttons.edit.type ? this.columns.buttons.edit.type : 'default'),
                size: (this.columns.buttons.edit.icon && !this.columns.buttons.edit.label) ? 'large' : 'small',
                icon: this.columns.buttons.edit.icon ? 'edit' : ''
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$emit('onEdit', params.row, params.column, params.index);
                }
              }
            }, this.columns.buttons.edit.label ? this.cTxtEdit : ''));
          }
          if (this.columns.buttons.delete) {
            res.push(h('Button', {
              props: {
                type: (this.columns.buttons.delete.icon && !this.columns.buttons.delete.label) ? 'text' : (this.columns.buttons.delete.type ? this.columns.buttons.delete.type : 'default'),
                size: (this.columns.buttons.delete.icon && !this.columns.buttons.delete.label) ? 'large' : 'small',
                icon: this.columns.buttons.delete.icon ? 'trash-b' : ''
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.$emit('onDelete', params.row, params.column, params.index);
                }
              }
            }, this.columns.buttons.delete.label ? this.cTxtDelete : ''));
          }
          if (this.columns.buttons.selfDef && this.columns.buttons.selfDef.length > 0) {
            this.columns.buttons.selfDef.forEach((item, index) => {
              res.push(h('Button', {
                props: {
                  type: (item.icon && !item.label) ? 'text' : item.type ? item.type : 'default',
                  size: (item.icon && !item.label) ? 'large' : 'small',
                  icon: item.icon
                },
                style: {
                  display: item.show === false ? 'none' : 'inline-block',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    item.handler(params);
                  }
                }
              }, item.label ? this.$t(item.label) : ''));
            });
          }
        }
        return res;
      },
      onSystemBtnClick(button) {
        switch (button.name) {
          case tableBtnNames.btnAdd:
            this.$router.push(button.url);
            break;
          case tableBtnNames.btnEdit:
            if (this.that.selection.length !== 1) {
              this.$Message.warning(this.$t('page.assemblyTable.selectOne'));
            } else {
              this.$router.push(button.url);
            }
            break;
          case tableBtnNames.btnDel:
            if (this.that.selection.length === 0) {
              this.$Message.warning(this.$t('page.assemblyTable.selectOneAtLeast'));
            } else {
              this.$Modal.confirm({
                title: this.$t('page.assemblyTable.confirmTitle'),
                content: this.$t('page.assemblyTable.confirmDelete'),
                onOk: () => {
                  this.$router.push(button.url);
                },
                onCancel: () => {
                }
              });
            }
            break;
          case tableBtnNames.btnImport:
            this.$router.push(button.url);
            break;
          case tableBtnNames.btnExport:
            button.loadding = true;
            this.$emit('onExportClick');
            break;
          default:
            break;
        }
      },
      onCustomBtnClick(button) {
        button.click(button);
      },
        // 获取选中数据
        getSelection() {
            return this.$refs['iTable'].getSelection();
        },
    },
    created() {
      if (this.columns.showCheckbox) {
        this.columns.columns.unshift(this.checkboxColumn);
      }
      if (this.columns.buttons) {
        this.columns.columns.push(this.buttonsColumn);
      }
    },
    watch: {
        columns: {
            handler () {
                this.columns = this.columns;
            },
            deep: true
        }
    }
  };
</script>

<style lang="less">
.m-table-title{
  height: auto;
}
</style>